import React, { useMemo } from 'react';

// work around Rendered more hooks than during the previous render
const UseMemo = ({ deps, children }) => {
  return useMemo(() => children, deps);
};

export default UseMemo;